// src/utils/activityLogger.js
import fc from '@/firebaseConfig'
import moment from 'moment'

/**
 * Logs user activity for a specific company and product.
 *
 * @param {string} companyID - The ID of the company for which the activity is being logged.
 * @param {string} [companyProduct=''] - The name of the company product. If not provided, the function returns early.
 * @param {string} [pageName=''] - The name of the page where the activity occurred.
 * @param {string} [eventName=''] - The name of the event being logged.
 * @param {Object} [eventParams={}] - Additional parameters for the event being logged.
 */

export const logUserActivity = (companyID, productType = '', targetPath = "", targetCollectionID = "", targetDocID = "", eventType = '',  eventDetails = {}, eventDesc = "", ) => {

  if(!companyID) return

  const user = fc.auth.currentUser
  const timeCreateString = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss:SSS')
  const timeStamp = moment().tz('Asia/Bangkok').toDate()

  const logData = {
    userID: user.uid,
    userData: {
      email: user.email,
      displayName: user.displayName
    },
    companyID: companyID,
    productType: productType,
    targetPath: targetPath,
    targetCollectionID: targetCollectionID,
    targetDocID: targetDocID,
    eventType: eventType,
    eventDetails: eventDetails,
    eventDesc: eventDesc,
    timeCreate: timeStamp,
    timeCreateLocale: timeCreateString
  }


  let logPath  = fc.db.collection(`Companies/${companyID}/PurchaseInvoices/${targetDocID}/UserActivities`).doc()
  logPath.set(logData)
  let logOuterPath = fc.db.collection(`Companies/${companyID}/UserActivities`).doc()
  logOuterPath.set(logData)
}

export const logUserActivityBatch = (companyID, productType = '', eventArr = []) => {

  // targetPath = "", targetDocId = "", eventType = '',  eventDetails = {}, eventDesc = "", 

  if(!companyID) return

  const user = fc.auth.currentUser
  const timeCreateString = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss:SSS')
  const logBatch = fc.db.batch()
  const timeStamp = moment().tz('Asia/Bangkok').toDate()

  eventArr.forEach((event) => {
    const { targetPath = "", targetCollectionID = "",  targetDocID = "", eventType = '',  eventDetails = {}, eventDesc = "", } = event


    const logData = {
      userID: user.uid,
      userData: {
        email: user.email,
        displayName: user.displayName
      },
      companyID: companyID,
      productType: productType,
      targetPath: targetPath,
      targetCollectionID: targetCollectionID,
      targetDocID: targetDocID,
      eventType: eventType,
      eventDetails: eventDetails,
      eventDesc: eventDesc,
      timeCreate: timeStamp,
      timeCreateLocale: timeCreateString
    }
  
    let logPath  = fc.db.collection(`Companies/${companyID}/PurchaseInvoices/${targetDocID}/UserActivities`).doc()
    logBatch.set(logPath, logData)
    let logOuterPath = fc.db.collection(`Companies/${companyID}/UserActivities`).doc()
    logBatch.set(logOuterPath, logData)
  })

  logBatch.commit().then(() => {
    console.log('Batch log success')
  }).catch((error) => {
    console.error('Batch log error', error)
  })
}



// this.userAction(EVENT_TYPES.CLICK, {
//   target_component: "<v-btn></v-btn>",
//   target_action: "refreshPurchasePdfFile",
//   target_action_desc: "Regenerate the Purchase Order document",
//   page_title: "DocumentPOAI",
// });